var Component = require("vue-loader/lib/component-normalizer")(
  /* name */
  "BreadcrumbsItem",
  /* script */
  require("!!buble-loader!vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./BreadcrumbsItem.vue"),
  /* template */
  require("!!vue-loader/lib/template-compiler?id=data-v-32acb19c!vue-loader/lib/template-loader?raw&engine=pug!vue-loader/lib/selector?type=template&index=0!./../../../node_modules/eslint-loader/index.js!./BreadcrumbsItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/breadcrumbs/BreadcrumbsItem.vue
// module id = 91
// module chunks = 0